export const HEADER_LINKS_TYPES = {
    DROPDOWN: 'DROPDOWN',
    EXTERNAL_LINK: 'EXTERNAL_LINK',
    FUNCTION: 'FUNCTION',
    ICON: 'ICON',
    ICON_REACT_ROUTER: 'ICON_REACT_ROUTER',
    LANGUAGE_SWITCH: 'LANGUAGE_SWITCH',
    LINK_AS_POPUP: 'LINK_AS_POPUP',
    LINK: 'LINK',
    MODAL: 'MODAL',
    LINKS_AND_ICONS: 'LINKS_AND_ICONS',
    TEXT: 'TEXT',
    TOOLTIP: 'TOOLTIP',
    CHAT:  'CHAT'
};

export const PA_EXCLUDES = ['/hix/', '/home', '/hix/accessCode', '/accessCode'];

export const EXTRA_ACTIONS = {
    CHECK_SSAP: 'CHECK_SSAP',
};
